<template>
  <div>
    <el-form label-width="120px" ref="form" :model="obj">
      <el-form-item label="用户手机号" prop="phone_number">
        <el-input v-model.number="obj.phone_number"></el-input>
      </el-form-item>
      <el-form-item label="确认手机号" prop="phone_number_makesure">
        <el-input v-model.number="obj.phone_number_makesure"></el-input>
      </el-form-item>
      <el-form-item label="用户数" prop="count">
        <el-input v-model.number="obj.count"></el-input>
      </el-form-item>
      <el-form-item label="用户开通时间" prop="year">
        <el-select v-model="obj.year" placeholder="请选择">
          <el-option v-for="(item,i) in yearList" :key="i" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="功能" prop="model">
        <el-checkbox-group v-model="obj.model">
          <el-checkbox label="3" name="type">3D</el-checkbox>
          <el-checkbox label="9" name="type">算料</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
	  <el-form-item label="充值额度" prop="money">
	    <el-input v-model.number="obj.money"></el-input>
	  </el-form-item>
	  <el-form-item label="签名">
	    <write-board ref="writeBoard"></write-board>
	  </el-form-item>
    </el-form>
    <el-button type="primary" @click="submit">确定设为代理商</el-button>
  </div>
</template>

<script>
import writeBoard from '@/components/writeBoard.vue'
export default {
  data:()=>({
    obj:{
      phone_number:'',
      phone_number_makesure:'',
      year:'',
      model:[],
      count:'',
	  money: ''   
    },
    yearList:[
      {label:'1年',value:1},
      {label:'2年',value:2},
      {label:'3年',value:3},
      {label:'永久',value:1000},
    ]
  }),
  methods:{
    async submit(){
      if(!/^1\d{10}$/.test(this.obj.phone_number)){
        this.$message.error("请输入正确的手机号！");
        return
      }
      if(!/^1\d{10}$/.test(this.obj.phone_number_makesure)){
        this.$message.error("请输入正确的手机号！");
        return
      }
      if(this.obj.phone_number!=this.obj.phone_number_makesure){
        this.$message.error("两次手机号不匹配！");
        return
      }
	  if(!this.obj.money){
	    this.$message.error("请输入代理商充值额度！");
	    return
	  }
	  let sign = await this.uploadImage(this.$refs['writeBoard'].getSign())
      var param = JSON.parse(JSON.stringify(this.obj))
	  param.sign = sign
      delete param.phone_number_makesure
      this.$axios.post('admin-up-dls',param).then(res=>{
        if(res.code==1){
          this.$message({
            message:res.message,
            type:"success"
          })
		  this.$refs['form'].resetFields()
		  this.$refs['writeBoard'].initBoardContent()
        }else{
          this.$message.error(res.message)
        }
      })
    },
	uploadImage(url) {
		let form_data = new FormData();
		form_data.append("file",url);
		return this.$axios.post("uploads",form_data).then(res=> {
		  if (res.code) return res.data;
		  else return '';
		})
	}
  },
  components:{
	  writeBoard
  }
}
</script>

<style>

</style>